class EngravingDetection {
 constructor(element){
  this.optionSelection = document.querySelector(element);
  this.optionsLabels = this.optionSelection.querySelectorAll(`.options-selection__select-label`);
  this.options = Array.from(this.optionsLabels).map(option => option.getAttribute("data-variant-option-name"));
  
  console.log(`this.options`,this.options);

  this.engravingSelectKey = this.options.findIndex(opt => 
   opt && opt.toLowerCase().includes('engraving')
 );
  
  this.variantSelect = this.optionSelection.querySelectorAll(`select.options-selection__input-select`)[this.engravingSelectKey];
  console.log(`variantSelect`,this.variantSelect);
  this.initVariables();
 }

 initVariables(){
  console.log(`variantSelect`,this.variantSelect);

  this.variantSelect.addEventListener('change', event => {
   this.detectChange(event);
  })
 }

 detectChange(event){
  const engravingValue = event.target.value;
  if( engravingValue.includes("Yes") || engravingValue.includes("yes") ){
   this.showEngravingInputs();
  }else{
   this.hideEngravingInputs();
  }
 }
 showEngravingInputs(){
  const engravingInputs = document.querySelector(`#infiniteoptions-container`);
  engravingInputs.style.display = 'block';
  
 }
 hideEngravingInputs(){
  const engravingInputs = document.querySelector(`#infiniteoptions-container`);
  engravingInputs.style.display = '';
  document.querySelectorAll(`#infiniteoptions-container input[type="text"]`).forEach((input) => {
   input.value = '';
  })
 }
}

new EngravingDetection(`options-selection`);
